module.exports = __webpack_public_path__ + "static/media/vision.01af09aa.svg";